import { Params } from 'app/types';

import { request } from '../config';

const DOCUMENTS_CSV_URL = 'documents.json';

export function getCSV(params: Params): Promise<any> {
  return request(
    {
      url: DOCUMENTS_CSV_URL,
      method: 'POST',
      params,
    },
    (data) => {
      return data.model;
    }
  );
}
